<template>
  <div
    class="error-tooltip-container"
    :class="{ 'hidden-visibility': !alwaysVisible }"
    :tabindex="focusable ? 0 : undefined"
    :role="focusable ? 'button' : undefined"
    :aria-label="focusable ? text : undefined"
    :aria-describedby="visible ? tooltipId : undefined"
    ref="tooltip"
    @mouseenter="showTooltip"
    @mouseleave="scheduleTooltipHide"
    @focusin="showTooltip"
    @focusout="hideTooltip"
    @keydown.esc.stop="hideTooltip"
    @keydown.enter.prevent="showTooltip"
    @keydown.space.prevent="showTooltip"
  >
    <span class="error-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/triangle-exclamation-solid-full-red.svg')"
        alt="Icon"
      />
    </span>
    <Teleport to="body">
      <div v-if="visible" :id="tooltipId" role="tooltip" ref="popup" class="error-popup" :style="popupStyle"
        @mouseenter="cancelTooltipHide" @mouseleave="scheduleTooltipHide">
        {{ text }}
      </div>
    </Teleport>
  </div>
</template>

<script>
import floatingTooltip from '@/utils/floatingTooltip';

export default {
  mixins: [floatingTooltip],
  props: {
    alwaysVisible: Boolean,
    focusable: Boolean,
    tooltipId: { type: String, default: undefined },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped src="@/styles/ErrorTooltip.css">

</style>
